module.exports = __webpack_public_path__ + "static/media/Component371.515462d6.svg";